import useFetchManifestLegPax from '../../../../hooks/useFetchManifestLegPax';
import CheckIcon from '../../../global-components/checkIcon';
import NoDataFound from '../../../global-components/no-data-found';

type Props = {
  manifestNo: string;
  manifestLegNumber: number | null;
};

const ManifestPassengersTable = ({ manifestNo, manifestLegNumber }: Props) => {
  const { data, isLoading } = useFetchManifestLegPax({
    manifestNo,
    manifestLegNumber,
  });

  const hasData = !!data && !!data?.length;
  return (
    <div className='ubbe-card h-100'>
      <div className='ubbe-card-header'>
        <h5 className='ps-3 mb-0 GlobalBoxHead'>Passengers</h5>
      </div>
      <div className='card-body p-2 h-auto'>
        <table className='table' id='lms-manifest-legs-table'>
          <thead className='ubbe-table-header'>
            <tr>
              <th className={`text-start ubbe-table-heading-text`} scope='col'>
                Name
              </th>
              <th className={`text-start ubbe-table-heading-text`} scope='col'>
                Weight (lbs)
              </th>
              <th className={`text-start ubbe-table-heading-text`} scope='col'>
                Baggage Weight (lbs)
              </th>
              <th className={`text-center ubbe-table-heading-text`} scope='col'>
                Checked in
              </th>
              <th className={`text-center ubbe-table-heading-text`} scope='col'>
                Boarded
              </th>
              <th className={`text-center ubbe-table-heading-text`} scope='col'>
                Completed Trip
              </th>
            </tr>
          </thead>
          <tbody id='set_lanes_rows' className='bg-white'>
            {!isLoading &&
              hasData &&
              data?.map((item: any) => (
                <tr key={item.no}>
                  <td className='align-middle'>{item.contact_name || 'N/A'}</td>
                  <td className='align-middle'>{item.weight || 'N/A'}</td>
                  <td className='align-middle'>
                    {item.baggage_weight_lbs || 'N/A'}
                  </td>
                  <td className='align-middle'>
                    <CheckIcon checked={item.checked_in} />
                  </td>
                  <td className='align-middle'>
                    <CheckIcon checked={item.boarded} />
                  </td>
                  <td className='align-middle'>
                    <CheckIcon checked={item.made_trip} />
                  </td>
                </tr>
              ))}
            {!isLoading && !hasData && (
              <tr>
                <td colSpan={8}>
                  <NoDataFound />
                </td>
              </tr>
            )}
            {isLoading && (
              <tr>
                <td colSpan={8}>
                  <div className='spinner-border' role='status'>
                    <span className='visually-hidden'></span>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ManifestPassengersTable;
